import { Either, pipe } from "fp";

import { type, creator, reducer, effects } from "~/Action";
import * as Data from "~/Data";
import * as Log from "~/Log";
import * as TimeTracking from "~/TimeTracking";

export namespace Requested {
  export const { TYPE, create, reduce } = pipe(
    type("Log requested" as const),
    creator((log: Log.Identity) => ({ log })),
    reducer(({ state, action: { log } }) => {
      state.logs.active = log;
      state.logs.store = Data.Store.requested(state.logs.store);
    }),
    effects(
      ({ dispatch }) => dispatch(TimeTracking.Entry.Action.Requested.create())
    )
  );
}

export namespace Clear {
  export const { TYPE, create, reduce } = pipe(
    type("Log cleared" as const),
    reducer(({ state }) => {
      state.logs.active = Log.Active.State.initial();
    })
  );
}

export namespace Received {
  export const { TYPE, create, reduce } = pipe(
    type("Log received" as const),
    creator((log: Log.Log) => ({ log })),
    reducer(
      ({ state, action: { log } }) =>
        (state.logs.store = pipe(
          state.logs.store,
          Data.Store.received(
            Either.right(
              pipe(
                [
                  {
                    ...log,
                  },
                ] as readonly Log.Log[],
                Data.Cache.fromList<Log.Log, Log.Log>((log) => [
                  Log.id(log),
                  log,
                ])
              )
            )
          )
        ) as typeof state.logs.store)
    )
  );
}
